type UserType = "ADMIN" | "MERCHANT_ADMIN" | "OPERATOR";

export interface SwitchProps {
    visible: boolean,
    enabled: boolean,
}

export interface UserParameters{
    viewEditSelf: boolean,
    authUser: {
        type: UserType | string,
        isDistributor: boolean
    },
    user: {
        type: UserType | string,
        isDistributor: boolean
    },
}

export interface DecisionTableProps extends UserParameters{
    switchProps: SwitchProps,
}

export const DISTRIBUTOR_TOGGLE_DECISION_TABLE: DecisionTableProps[] = [

    // ***************************************************** authUser = ADMIN *****************************************************

    // View / edit SELF
    {
        viewEditSelf: true,
        authUser: {
            type: "ADMIN",
            isDistributor: false,
        },
        user: {
            type: "ADMIN",
            isDistributor: false,
        },
        switchProps: {
            visible: false,
            enabled: false,
        },
    },
    // View / edit user ADMIN
    {
        viewEditSelf: false,
        authUser: {
            type: "ADMIN",
            isDistributor: false,
        },
        user: {
            type: "ADMIN",
            isDistributor: false,
        },
        switchProps: {
            visible: false,
            enabled: false,
        },
    },
    // View / edit user MERCHANT ADMIN, DISTRIBUTOR
    {
        viewEditSelf: false,
        authUser: {
            type: "ADMIN",
            isDistributor: false,
        },
        user: {
            type: "MERCHANT_ADMIN",
            isDistributor: true,
        },
        switchProps: {
            visible: true,
            enabled: true,
        },
    },
    // View / edit user MERCHANT ADMIN, NON-DISTRIBUTOR
    {
        viewEditSelf: false,
        authUser: {
            type: "ADMIN",
            isDistributor: false,
        },
        user: {
            type: "MERCHANT_ADMIN",
            isDistributor: false,
        },
        switchProps: {
            visible: true,
            enabled: true,
        },
    },
    // View / edit user OPERATOR
    {
        viewEditSelf: false,
        authUser: {
            type: "ADMIN",
            isDistributor: false,
        },
        user: {
            type: "OPERATOR",
            isDistributor: false,
        },
        switchProps: {
            visible: true,
            enabled: true,
        },
    },
    // View / edit user OPERATOR, DISTRIBUTOR
    {
        viewEditSelf: false,
        authUser: {
            type: "ADMIN",
            isDistributor: false,
        },
        user: {
            type: "OPERATOR",
            isDistributor: true,
        },
        switchProps: {
            visible: true,
            enabled: true,
        },
    },
    
    // ***************************************************** authUser = MERCHANT ADMIN, DISTRIBUTOR *****************************************************

    // View / edit SELF, DISTRIBUTOR
    {
        viewEditSelf: true,
        authUser: {
            type: "MERCHANT_ADMIN",
            isDistributor: true,
        },
        user: {
            type: "MERCHANT_ADMIN",
            isDistributor: true,
        },
        switchProps: {
            visible: true,
            enabled: false,
        },
    },
    // View / edit user MERCHANT ADMIN
    {
        viewEditSelf: false,
        authUser: {
            type: "MERCHANT_ADMIN",
            isDistributor: true,
        },
        user: {
            type: "MERCHANT_ADMIN",
            isDistributor: false,
        },
        switchProps: {
            visible: true,
            enabled: true,
        },
    },
    // View / edit user MERCHANT ADMIN, DISTRIBUTOR
    {
        viewEditSelf: false,
        authUser: {
            type: "MERCHANT_ADMIN",
            isDistributor: true,
        },
        user: {
            type: "MERCHANT_ADMIN",
            isDistributor: true,
        },
        switchProps: {
            visible: true,
            enabled: true,
        },
    },
    // View / edit user OPERATOR
    {
        viewEditSelf: false,
        authUser: {
            type: "MERCHANT_ADMIN",
            isDistributor: true,
        },
        user: {
            type: "OPERATOR",
            isDistributor: false,
        },
        switchProps: {
            visible: true,
            enabled: true,
        },
    },
    // View / edit user OPERATOR, DISTRIBUTOR
    {
        viewEditSelf: false,
        authUser: {
            type: "MERCHANT_ADMIN",
            isDistributor: true,
        },
        user: {
            type: "OPERATOR",
            isDistributor: true,
        },
        switchProps: {
            visible: true,
            enabled: true,
        },
    },

    // ***************************************************** authUser = MERCHANT ADMIN, NON-DISTRIBUTOR *****************************************************

    // View / edit SELF
    {
        viewEditSelf: true,
        authUser: {
            type: "MERCHANT_ADMIN",
            isDistributor: false,
        },
        user: {
            type: "MERCHANT_ADMIN",
            isDistributor: false,
        },
        switchProps: {
            visible: false,
            enabled: false,
        },
    },
    // View / edit user MERCHANT ADMIN
    {
        viewEditSelf: false,
        authUser: {
            type: "MERCHANT_ADMIN",
            isDistributor: false,
        },
        user: {
            type: "MERCHANT_ADMIN",
            isDistributor: false,
        },
        switchProps: {
            visible: false,
            enabled: false,
        },
    },
    // View / edit user MERCHANT ADMIN, DISTRIBUTOR
    {
        viewEditSelf: false,
        authUser: {
            type: "MERCHANT_ADMIN",
            isDistributor: false,
        },
        user: {
            type: "MERCHANT_ADMIN",
            isDistributor: true,
        },
        switchProps: {
            visible: false,
            enabled: false,
        },
    },
    // View / edit user OPERATOR
    {
        viewEditSelf: false,
        authUser: {
            type: "MERCHANT_ADMIN",
            isDistributor: false,
        },
        user: {
            type: "OPERATOR",
            isDistributor: false,
        },
        switchProps: {
            visible: false,
            enabled: false,
        },
    },
    // View / edit user OPERATOR, DISTRIBUTOR
    {
        viewEditSelf: false,
        authUser: {
            type: "MERCHANT_ADMIN",
            isDistributor: false,
        },
        user: {
            type: "OPERATOR",
            isDistributor: true,
        },
        switchProps: {
            visible: false,
            enabled: false,
        },
    },

    // ***************************************************** authUser = OPERATOR, DISTRIBUTOR *****************************************************

    // View / edit SELF, DISTRIBUTOR
    {
        viewEditSelf: true,
        authUser: {
            type: "OPERATOR",
            isDistributor: true,
        },
        user: {
            type: "OPERATOR",
            isDistributor: true,
        },
        switchProps: {
            visible: true,
            enabled: false,
        },
    },
    // View / edit user MERCHANT ADMIN
    {
        viewEditSelf: false,
        authUser: {
            type: "OPERATOR",
            isDistributor: true,
        },
        user: {
            type: "MERCHANT_ADMIN",
            isDistributor: false,
        },
        switchProps: {
            visible: true,
            enabled: false,
        },
    },
    // View / edit user MERCHANT ADMIN, DISTRIBUTOR
    {
        viewEditSelf: false,
        authUser: {
            type: "OPERATOR",
            isDistributor: true,
        },
        user: {
            type: "MERCHANT_ADMIN",
            isDistributor: true,
        },
        switchProps: {
            visible: true,
            enabled: false,
        },
    },
    // View / edit user OPERATOR
    {
        viewEditSelf: false,
        authUser: {
            type: "OPERATOR",
            isDistributor: true,
        },
        user: {
            type: "OPERATOR",
            isDistributor: false,
        },
        switchProps: {
            visible: true,
            enabled: true,
        },
    },
    // View / edit user OPERATOR, DISTRIBUTOR
    {
        viewEditSelf: false,
        authUser: {
            type: "OPERATOR",
            isDistributor: true,
        },
        user: {
            type: "OPERATOR",
            isDistributor: true,
        },
        switchProps: {
            visible: true,
            enabled: true,
        },
    },

        // ***************************************************** authUser = OPERATOR, NON-DISTRIBUTOR *****************************************************

    // View / edit SELF
    {
        viewEditSelf: true,
        authUser: {
            type: "OPERATOR",
            isDistributor: false,
        },
        user: {
            type: "OPERATOR",
            isDistributor: false,
        },
        switchProps: {
            visible: false,
            enabled: false,
        },
    },
    // View / edit user MERCHANT ADMIN
    {
        viewEditSelf: false,
        authUser: {
            type: "OPERATOR",
            isDistributor: false,
        },
        user: {
            type: "MERCHANT_ADMIN",
            isDistributor: false,
        },
        switchProps: {
            visible: false,
            enabled: false,
        },
    },
    // View / edit user MERCHANT ADMIN, DISTRIBUTOR
    {
        viewEditSelf: false,
        authUser: {
            type: "OPERATOR",
            isDistributor: false,
        },
        user: {
            type: "MERCHANT_ADMIN",
            isDistributor: true,
        },
        switchProps: {
            visible: false,
            enabled: false,
        },
    },
    // View / edit user OPERATOR
    {
        viewEditSelf: false,
        authUser: {
            type: "OPERATOR",
            isDistributor: false,
        },
        user: {
            type: "OPERATOR",
            isDistributor: false,
        },
        switchProps: {
            visible: false,
            enabled: false,
        },
    },
    // View / edit user OPERATOR, DISTRIBUTOR
    {
        viewEditSelf: false,
        authUser: {
            type: "OPERATOR",
            isDistributor: false,
        },
        user: {
            type: "OPERATOR",
            isDistributor: true,
        },
        switchProps: {
            visible: false,
            enabled: false,
        },
    },

];